import { jsx as s } from "react/jsx-runtime";
import "@market/market-theme/css/core/index.css";
import l from "./styles/MarketSlider.module.js";
const d = (i) => {
  const {
    disabled: o = !1,
    min: e = 0,
    max: r = 100,
    step: c = 1,
    value: a = 0,
    onChange: g
  } = i, m = ((t) => {
    const n = r - e;
    return n === 0 ? 0 : (t - e) / n;
  })(a), p = (t) => {
    g?.(t.target.valueAsNumber);
  };
  return /* @__PURE__ */ s("div", { className: l.slider, style: { "--value-percentage": `${m * 100}%` }, children: /* @__PURE__ */ s(
    "input",
    {
      type: "range",
      className: l.input,
      disabled: o,
      min: e,
      max: r,
      step: c,
      value: a,
      onChange: p
    }
  ) });
};
d.displayName = "MarketSlider";
export {
  d as MarketSlider
};
